import { useEffect, useState } from "react";

export default function GuestToast() {
  const [message, setMessage] = useState("");
  useEffect(() => {
    const handler = (event) => {
      setMessage(event.detail || "");
      window.clearTimeout(window.__a1GuestToastTimer);
      window.__a1GuestToastTimer = window.setTimeout(() => setMessage(""), 2200);
    };
    window.addEventListener("a1GuestToast", handler);
    return () => window.removeEventListener("a1GuestToast", handler);
  }, []);
  if (!message) return null;
  return <div className="fixed left-4 right-4 top-5 z-[9999] rounded-xl bg-[#0F766E] px-5 py-3 text-center text-sm font-semibold text-white shadow-xl sm:left-auto sm:right-5">{message}</div>;
}
